import { Component } from 'react';
import { getEntitiesPrompts, getPrompts } from './query';
import { tags } from './config';
import { withTranslation } from 'react-i18next';
import BrandEntities from './components/brands';
import Entities from './components/Entities';
import { getPromptCredits } from '../promptGenerator/query';

class AiTrackingPromptHistory extends Component {
    constructor(props) {
        super();
        this.addActive = this.addActive.bind(this);
        this.onChangeTags = this.onChangeTags.bind(this);
        this.getBrandsPrompts = this.getBrandsPrompts.bind(this);
        this.getEntitiesPrompts = this.getEntitiesPrompts.bind(this);
        this.getPromptCounts = this.getPromptCounts.bind(this);
        this.url = new URL(window.location);

        let view = this.url.searchParams.get('view');

        if (!view) {
            view = tags(props.t)[0].id;
        }

        this.state = {
            prompts: [],
            entitiesPrompts: [],
            loading: true,
            entitiesLoading: true,
            type: view,
            promptCredits: 0,
        };
    }

    async getPromptCounts() {
        try {
            const response = await getPromptCredits();
            const data = await response.json();
            const promptCount =
                data?.allowed_per_plan + data?.extra_allowed - data?.total_used || 0;

            this.setState({
                promptCredits: promptCount,
            });
        } catch (err) {
            console.log('err', err);
        }
    }

    async getBrandsPrompts() {
        try {
            const res = await getPrompts();
            const data = await res.json();
            this.setState({
                prompts: data?.filter((item) => item?.generated_prompts?.length > 0) || [],
                loading: false,
            });
        } catch (err) {
            console.log('err', err);
            this.setState({
                loading: false,
            });
        }
    }

    async getEntitiesPrompts() {
        try {
            const res = await getEntitiesPrompts();
            const data = await res.json();
            this.setState({
                entitiesPrompts: data?.filter((item) => item?.entity_prompts?.length > 0) || [],
                entitiesLoading: false,
            });
        } catch (err) {
            console.log('err', err);
            this.setState({
                entitiesLoading: false,
            });
        }
    }

    async componentDidMount() {
        this.getBrandsPrompts();
        this.getEntitiesPrompts();
    }

    addActive(id) {
        return this.state.type === id;
    }

    onChangeTags(id) {
        this.url.searchParams.set('view', id);
        history.pushState({}, '', this.url);

        this.setState({
            type: id,
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div>
                <div className="main tags-container">
                    {tags(t).map((tag) =>
                        tag.link ? (
                            <a
                                className="tab-item"
                                key={tag.id}
                                href={tag.link}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t(`opportunities.tabs.${tag.id}`, { defaultValue: tag.label })}
                            </a>
                        ) : (
                            <span
                                className={`tab-item ${this.addActive(tag.id) && 'active-tag'}`}
                                key={tag.id}
                                onClick={() => this.onChangeTags(tag.id)}
                            >
                                {t(`opportunities.tabs.${tag.id}`, { defaultValue: tag.label })}
                            </span>
                        ),
                    )}
                </div>

                <div>
                    <div
                        style={{
                            display:
                                this.state.type === 'brand_to_entities_to_prompts'
                                    ? 'block'
                                    : 'none',
                        }}
                    >
                        <BrandEntities items={this.state.prompts} loading={this.state.loading} />
                    </div>
                    <div style={{ display: this.state.type === 'entities' ? 'block' : 'none' }}>
                        <Entities
                            items={this.state.entitiesPrompts}
                            loading={this.state.entitiesLoading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(AiTrackingPromptHistory);
